import React, { useEffect, useRef, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Button,Modal, ModalHeader, ModalFooter, ModalBody,
} from "reactstrap";

function ConfirmModal(props) {
    const {
        modal = false,
        toggle,
        showToggle,
        modalHeaderContent="ยืนยัน?",
        modalBodyContent,
        showModalFooter=true,
        modalFooterContent,
        backdrop=true,
        modalSize="sm",
        centered=true,
        confirmBtnText="ตกลง",
        confirmBtnIcon,
        cancelBtnText="ยกเลิก",
        cancelBtnIcon,
        onClickConfirmBtn,
        onClickCancelBtn,
        disabledBtn = false,
        taskName = ""

    } = props;

    const [isConfirming, setIsConfirming] = useState(false);
    // ใช้ ref คู่กับ state เพราะ state ยังไม่อัปเดตทันในจังหวะดับเบิลคลิกเร็ว ๆ (ปุ่มยัง disabled ไม่ทัน)
    const isConfirmingRef = useRef(false);

    // component นี้ถูก mount ค้างไว้ (ปิดด้วย isOpen ไม่ได้ unmount) จึงต้องรีเซ็ตเองทุกครั้งที่เปิดใหม่
    useEffect(() => {
      if (modal) {
        isConfirmingRef.current = false;
        setIsConfirming(false);
      }
    }, [modal]);

    // กันกดปุ่มยืนยันซ้ำ: ล็อกตั้งแต่คลิกแรกจนกว่างานจะเสร็จ
    // await รองรับทั้ง handler แบบ sync (ได้ undefined) และ async ที่ยิง API ยาว ๆ
    const handleConfirmClick = async () => {
      if (!onClickConfirmBtn || isConfirmingRef.current) return;
      isConfirmingRef.current = true;
      setIsConfirming(true);
      try {
        await onClickConfirmBtn();
      } catch (error) {
        console.error("ConfirmModal:", error);
        // ล้มเหลว = ปลดล็อกให้กดยืนยันใหม่ได้ (modal ยังเปิดค้างอยู่)
        isConfirmingRef.current = false;
        setIsConfirming(false);
      }
    };

    const handleCancelClick = () => {
      onClickCancelBtn && onClickCancelBtn();
      toggle && toggle(false);
    };

    const isBusy = disabledBtn || isConfirming;

return (
<FadeIn>
    <Modal backdrop={backdrop} isOpen={modal} size={modalSize} centered={centered}>

      {modalHeaderContent ? <ModalHeader toggle={ showToggle ? () => { toggle(false) }: undefined }>{modalHeaderContent} {taskName && <><span className="px-1 text-success">{taskName} </span><span>ใช่หรือไม่</span></> } </ModalHeader> : ""}

      {modalBodyContent ? <ModalBody>{modalBodyContent}</ModalBody> : ""}

      {showModalFooter ? <ModalFooter>
        {modalFooterContent ? modalFooterContent : 
        <>
        <Button color="success" onClick={() => {handleConfirmClick()}} disabled={isBusy}>
          {confirmBtnIcon ? isBusy ? <i class="fa-solid fa-floppy-disk pe-2 fa-fade"></i> : <i class="fa-solid fa-floppy-disk pe-2"></i> : ""}{confirmBtnText}
        </Button>{' '}
        <Button color="danger" onClick={() => {onClickCancelBtn ? handleCancelClick() : toggle(false)}} disabled={isBusy}>
          {cancelBtnIcon ? <i class="fa-solid fa-xmark pe-2"/> : ""}{cancelBtnText}
        </Button>
        </>
        }
      </ModalFooter> : ""}

    </Modal>
</FadeIn>
);}

export default ConfirmModal;